import { Box, Paper, Typography, Stack, CircularProgress } from '@mui/material';
import MonacoYamlEditor from 'src/components/MonacoYamlEditor';
import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import * as yaml from 'js-yaml';
import { getTankResourceDetail } from 'src/api';
import message from 'src/components/message';

export default function TankTypeSecondDetail() {
  const [searchParams] = useSearchParams();
  const key = searchParams.get('key');
  
  const [detail, setDetail] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  // 获取详情数据
  useEffect(() => {
    if (key) {
      const fetchDetail = async () => {
        try {
          setLoading(true);
          const response: any = await getTankResourceDetail(key);
          console.log('getTankResourceDetail response:', response);
          
          if (response && response.data) {
            setDetail(response.data);
          } else {
            message.error({ content: '获取详情数据失败' });
          }
        } catch (error) {
          console.error('获取详情失败:', error);
          message.error({ content: '获取详情数据失败' });
        } finally {
          setLoading(false);
        }
      };
      fetchDetail();
    }
  }, [key]);

  if (loading) {
    return (
      <Box sx={{ maxWidth: 700, mx: 'auto', mt: 4, textAlign: 'center' }}>
        <CircularProgress />
        <Typography sx={{ mt: 2 }}>加载中...</Typography>
      </Box>
    );
  }

  if (!detail) {
    return (
      <Box sx={{ maxWidth: 700, mx: 'auto', mt: 4 }}>
        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" color="error">
            未找到对应的数据
          </Typography>
        </Paper>
      </Box>
    );
  }

  let yamlString = '# 暂无配置内容';
  if (detail.data) {
    try {
      const jsonData = detail.data;
      console.log('jsonData:', jsonData);
      yamlString = yaml.dump(jsonData);
    } catch (e) {
      console.error('Error converting JSON to YAML:', e);
      yamlString = `# 内容不是有效的JSON格式, 无法转换为YAML:\n\n${detail.data}`;
    }
  }

  return (
    <Box sx={{ maxWidth: 700, mx: 'auto', mt: 4 }}>
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          二级分类详情
        </Typography>
        
        <Stack direction="row" spacing={4} alignItems="center" sx={{ mb: 2 }}>
          <Typography variant="subtitle1" color="text.secondary">
            分类名称：
          </Typography>
          <Typography variant="body1">{detail.key || '未知'}</Typography>
        </Stack>
        
        <Stack direction="row" spacing={4} alignItems="center" sx={{ mb: 2 }}>
          <Typography variant="subtitle1" color="text.secondary">
            所属一级分类：
          </Typography>
          <Typography variant="body1">{detail.category.name || '未知'}</Typography>
        </Stack>
        
        <Stack direction="row" spacing={4} alignItems="center" sx={{ mb: 2 }}>
          <Typography variant="subtitle1" color="text.secondary">
            版本：
          </Typography>
          <Typography variant="body1">{detail.current_version || '未知'}</Typography>
        </Stack>
        
        <Box>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 500 }}>
            YAML 配置内容
          </Typography>
          <Paper 
            variant="outlined" 
            sx={{ 
              minHeight: 240, 
              p: 0, 
              borderRadius: 2, 
              overflow: 'hidden', 
              bgcolor: '#f7f9fa',
              boxShadow: '0 1px 4px 0 rgba(0,0,0,0.04)',
              transition: 'box-shadow 0.2s',
              '&:hover': {
                boxShadow: '0 4px 16px 0 rgba(0,0,0,0.10)',
              },
              mb: 2,
            }}
          >
            <MonacoYamlEditor
              height="240px"
              value={yamlString}
              readOnly={true}
            />
          </Paper>
        </Box>
      </Paper>
    </Box>
  );
}